import { createGetPropGetter } from '@/store/utils';

export default {
  companySuggestionsForSP: createGetPropGetter('companySuggestionsForSP', []),
  spCompanyRegistrationMainInfo: createGetPropGetter('spCompanyRegistrationMainInfo', {}),
  spCompanyAmountOfEmployees: createGetPropGetter('spCompanyAmountOfEmployees', []),
  spCompanyRegions: createGetPropGetter('spCompanyRegions', []),
  spCompanyRegistrationCompanySocialNetworkLinkInfo: createGetPropGetter('spCompanyRegistrationCompanySocialNetworkLinkInfo', {}),
  spCompanyRegistrationCompanyIpAddressInfo: createGetPropGetter('spCompanyRegistrationCompanyIpAddressInfo', {}),
  spCompanyRegistrationCompanyRecommendationInfo: createGetPropGetter('spCompanyRegistrationCompanyRecommendationInfo', {}),
  spCompanyCertificates: createGetPropGetter('spCompanyCertificates', []),
  spCompanyServices: createGetPropGetter('spCompanyServices', []),
  spCompanyServicesInfo: createGetPropGetter('spCompanyServicesInfo', {}),
  spCompanyRegistrationEmailVerificationInfo: createGetPropGetter('spCompanyRegistrationEmailVerificationInfo', {}),
  spCompanyCurrentStep: createGetPropGetter('spCompanyCurrentStep', 1),
  spCompanyVisitedStepsCnt: createGetPropGetter('spCompanyVisitedStepsCnt', 1),
  spCompanyFilledStepsCnt: createGetPropGetter('spCompanyFilledStepsCnt', 0),
  spCompanyLoading: createGetPropGetter('spCompanyLoading', {}),
  spCompanyLoadingErrors: createGetPropGetter('spCompanyLoadingErrors', {}),
  spCompanyRecaptchaToken: createGetPropGetter('spCompanyRecaptchaToken'),
  spCompanyEmailVerificationSent: createGetPropGetter('spCompanyEmailVerificationSent'),
  spCompanyClientAvatar: createGetPropGetter('spCompanyClientAvatar'),
  spCompanyRegistrationCompanyCertificationInfo: createGetPropGetter('spCompanyRegistrationCompanyCertificationInfo'),
  allowNextFirstStepSPCompany: state => Boolean(
    state.spCompanyRegistrationMainInfo.officeLocation &&
    state.spCompanyRegistrationMainInfo.employeesNumber &&
    state.spCompanyRegistrationMainInfo.organizationName &&
    state.spCompanyRegistrationMainInfo.organizationDomain,
  ),
  allowNextSecondStepSPCompany: state => Boolean(
    state.spCompanyServicesInfo.yearsOfExperience &&
    state.spCompanyServicesInfo.servicesChosen != null &&
    state.spCompanyServicesInfo.valid,
  ),
  allowNextThirdStepSPCompany: state => Boolean(
    state.spCompanyRegistrationCompanyIpAddressInfo &&
      state.spCompanyRegistrationCompanyIpAddressInfo.valid &&
      state.spCompanyRegistrationCompanySocialNetworkLinkInfo.valid &&
      state.spCompanyRegistrationCompanySocialNetworkLinkInfo.linkedinLink,
  ),
  allowNextForthStepSPCompany: state => Boolean(
    state.spCompanyRegistrationEmailVerificationInfo.valid &&
    state.spCompanyRegistrationEmailVerificationInfo.workEmail &&
    state.spCompanyRegistrationEmailVerificationInfo.password &&
    state.spCompanyRegistrationEmailVerificationInfo.firstName &&
    state.spCompanyRegistrationEmailVerificationInfo.lastName &&
    state.spCompanyRegistrationEmailVerificationInfo.phoneNumber &&
    state.spCompanyRegistrationEmailVerificationInfo.confirmPassword &&
    state.spCompanyRegistrationEmailVerificationInfo.confirmPassword === state.spCompanyRegistrationEmailVerificationInfo.password,
  ),
};
